import { GeoLocationSdkLoadError, GeoLocationTokenError } from './geo-location-errors'

export interface GeoFaultInjector {
	queueSdkLoadFault(): void
	queueSdkLoadTimeoutFault(): void
	queueSdkLoadTokenFault(): void
	queueLocateTimeoutFault(): void
	queueTokenFault(): void
	nextSdkLoadFault(): GeoLocationSdkLoadError | null
	nextSdkLoadTimeoutFault(): boolean
	nextSdkLoadTokenFault(): boolean
	nextLocateTimeoutFault(): boolean
	nextTokenFault(): GeoLocationTokenError | null
}

export function createFaultInjector(): GeoFaultInjector {
	let sdkLoadFault: GeoLocationSdkLoadError | null = null
	let sdkLoadTimeoutFault = false
	let sdkLoadTokenFault = false
	let locateTimeoutFault = false
	let tokenFault: GeoLocationTokenError | null = null

	return {
		queueSdkLoadFault() { sdkLoadFault = new GeoLocationSdkLoadError() },
		queueSdkLoadTimeoutFault() { sdkLoadTimeoutFault = true },
		queueSdkLoadTokenFault() { sdkLoadTokenFault = true },
		queueLocateTimeoutFault() { locateTimeoutFault = true },
		queueTokenFault() { tokenFault = new GeoLocationTokenError() },
		nextSdkLoadFault() { const f = sdkLoadFault; sdkLoadFault = null; return f },
		nextSdkLoadTimeoutFault() { const f = sdkLoadTimeoutFault; sdkLoadTimeoutFault = false; return f },
		nextSdkLoadTokenFault() { const f = sdkLoadTokenFault; sdkLoadTokenFault = false; return f },
		nextLocateTimeoutFault() { const f = locateTimeoutFault; locateTimeoutFault = false; return f },
		nextTokenFault() { const f = tokenFault; tokenFault = null; return f },
	}
}

let activeFaultInjector: GeoFaultInjector | null = null

export function installFaultInjector(injector: GeoFaultInjector): void {
	if (activeFaultInjector !== null) throw new Error('FaultInjector already installed — call uninstallFaultInjector() first')
	activeFaultInjector = injector
}

export function uninstallFaultInjector(): void {
	activeFaultInjector = null
}

export function getFaultInjector(): GeoFaultInjector | null {
	return activeFaultInjector
}
